import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-13d4c773"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "detail-content"
};
const _hoisted_2 = {
  class: "detail-row"
};
const _hoisted_3 = {
  class: "detail-item"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "内购ID：", -1));
const _hoisted_5 = {
  class: "value"
};
const _hoisted_6 = {
  class: "detail-row"
};
const _hoisted_7 = {
  class: "detail-item"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "用户UID：", -1));
const _hoisted_9 = {
  class: "value"
};
const _hoisted_10 = {
  class: "detail-row"
};
const _hoisted_11 = {
  class: "detail-item"
};
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "支付渠道：", -1));
const _hoisted_13 = {
  class: "value"
};
const _hoisted_14 = {
  class: "detail-row"
};
const _hoisted_15 = {
  class: "detail-item"
};
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "设备型号：", -1));
const _hoisted_17 = {
  class: "value"
};
const _hoisted_18 = {
  class: "detail-row"
};
const _hoisted_19 = {
  class: "detail-item"
};
const _hoisted_20 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "应用版本：", -1));
const _hoisted_21 = {
  class: "value"
};
const _hoisted_22 = {
  class: "detail-row"
};
const _hoisted_23 = {
  class: "detail-item"
};
const _hoisted_24 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "操作系统：", -1));
const _hoisted_25 = {
  class: "value"
};
const _hoisted_26 = {
  class: "detail-row"
};
const _hoisted_27 = {
  class: "detail-item"
};
const _hoisted_28 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "支付完成时间：", -1));
const _hoisted_29 = {
  class: "value"
};
const _hoisted_30 = {
  class: "detail-row"
};
const _hoisted_31 = {
  class: "detail-item"
};
const _hoisted_32 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "订单创建时间：", -1));
const _hoisted_33 = {
  class: "value"
};
import { ref, reactive } from 'vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'DuplicateDetail',
  setup(__props, {
    expose
  }) {
    const visible = ref(false);
    const orderInfo = reactive({
      prodId: '',
      payChnl: '',
      userId: '',
      appVer: '',
      os: '',
      model: '',
      thirdPayTime: '',
      createDate: ''
    });
    const handleCancel = () => {
      visible.value = false;
    };
    // 打开弹窗并设置数据
    const open = data => {
      orderInfo.prodId = data.prodId || '-';
      orderInfo.payChnl = data.payChnl || '-';
      orderInfo.userId = data.userId || '-';
      orderInfo.appVer = data.appVer || '-';
      orderInfo.os = data.os || '';
      orderInfo.model = data.model || '-';
      orderInfo.thirdPayTime = data.thirdPayTime || '-';
      orderInfo.createDate = data.createDate || '-';
      visible.value = true;
    };
    expose({
      open
    });
    return (_ctx, _cache) => {
      const _component_a_modal = _resolveComponent("a-modal");
      return _openBlock(), _createBlock(_component_a_modal, {
        open: visible.value,
        "onUpdate:open": _cache[0] || (_cache[0] = $event => visible.value = $event),
        title: "订单详情",
        width: 840,
        centered: "",
        onCancel: handleCancel,
        footer: null
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("span", _hoisted_5, _toDisplayString(orderInfo.prodId), 1)])]), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_hoisted_8, _createElementVNode("span", _hoisted_9, _toDisplayString(orderInfo.userId), 1)])]), _createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_hoisted_12, _createElementVNode("span", _hoisted_13, _toDisplayString(orderInfo.payChnl), 1)])]), _createElementVNode("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, [_hoisted_16, _createElementVNode("span", _hoisted_17, _toDisplayString(orderInfo.model), 1)])]), _createElementVNode("div", _hoisted_18, [_createElementVNode("div", _hoisted_19, [_hoisted_20, _createElementVNode("span", _hoisted_21, _toDisplayString(orderInfo.appVer), 1)])]), _createElementVNode("div", _hoisted_22, [_createElementVNode("div", _hoisted_23, [_hoisted_24, _createElementVNode("span", _hoisted_25, _toDisplayString(orderInfo.os == '2' ? 'IOS' : 'Android'), 1)])]), _createElementVNode("div", _hoisted_26, [_createElementVNode("div", _hoisted_27, [_hoisted_28, _createElementVNode("span", _hoisted_29, _toDisplayString(orderInfo.thirdPayTime), 1)])]), _createElementVNode("div", _hoisted_30, [_createElementVNode("div", _hoisted_31, [_hoisted_32, _createElementVNode("span", _hoisted_33, _toDisplayString(orderInfo.createDate), 1)])])])]),
        _: 1
      }, 8, ["open"]);
    };
  }
});